// extracted by mini-css-extract-plugin
export default {"wrapper":"Banner_wrapper__6P0zW","isFullWidth":"Banner_isFullWidth__wS1gG","sliderBanner":"Banner_sliderBanner__+MFyC","inner":"Banner_inner__n-XgH"};